import { render, staticRenderFns } from "./KnProductSubcategories.vue?vue&type=template&id=1d180d30"
import script from "./KnProductSubcategories.js?vue&type=script&lang=js&external"
export * from "./KnProductSubcategories.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports